import { Helmet } from 'react-helmet-async';
import { prune } from '../../config/schema';

// Escapes the 3 characters that could let a value inside our JSON-LD break
// out of the <script> element (most importantly "<" -- without it, a
// description or project name containing "</script>" would prematurely
// close the tag and let the rest be parsed as HTML/markup). Schema.org/JSON
// don't use any of these characters structurally, so escaping them is
// invisible to any consumer parsing the script as JSON.
const escapeForScript = (json) =>
  json.replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026');

// Renders one <script type="application/ld+json"> per page via
// react-helmet-async, which already replaces its previous tag whenever the
// component re-renders with new props (route change, language change) --
// no manual cleanup needed, and no risk of stacking duplicate scripts.
//
// `graph` is either a single JSON-LD node or an array of nodes; they're
// wrapped in one `@graph` under a shared @context. Nodes that end up
// undefined after pruning (e.g. a conditional entity that wasn't built)
// are dropped. If nothing survives pruning, no script is rendered at all.
const JsonLd = ({ graph }) => {
  const nodes = Array.isArray(graph) ? graph : [graph];
  const cleaned = nodes.map(prune).filter((node) => node !== undefined);

  if (cleaned.length === 0) return null;

  const payload = {
    '@context': 'https://schema.org',
    '@graph': cleaned,
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {escapeForScript(JSON.stringify(payload))}
      </script>
    </Helmet>
  );
};

export default JsonLd;